import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
export function PopupError(props) {
    const { text } = props;
    return (_jsx(Box, { display: "flex", flexDirection: "column", width: "100%", justifyContent: "center", children: _jsx(Box, { mt: 1, children: _jsx(Typography, { variant: "subtitle1", color: "error", children: text }) }) }));
}
